import React from "react"
import MetaButton from "@components/MetaButton/version2"
import useCustomTranslation from "@hooks/useCustomTranslation"

import { useRedirectToPro } from "@hooks/siteURLs"

const MainTitleAndDescription = ({ theme, dataEvent, countryName }) => {
  const { t } = useCustomTranslation()
  const url = useRedirectToPro()

  //bg-lblue theme by default
  let background = "bg-lblue"
  let titleColor = "text-dblue"
  let color = "text-g82"
  let icon = "invert-0"

  switch (theme) {
    case "bg-dblue":
      background = "bg-dblue"
      titleColor = "text-white"
      color = "text-g70"
      icon = "invert"
      break
  }

  const bgClass = `
  ${background}
  flex 
  items-center 
  justify-center 
  `
  const titleClass = `
  ${titleColor}  
  font-inter 
  text-[20px]   
  font-medium
  pb-2
  `
  const textClass = `
  ${color}  
  font-inter 
  text-[16px]   
  font-normal
  mt-3
  `
  const iconClass = `
  ${icon}
  pt-1 
  md:pt-0
`
  return (
    <div className={bgClass}>
      <div
        className="desk:flex flex-col p-0 
	  		desk:mt-[100px] desk:mb-[100px] 
			mt-[32px] mb-[32px] 
			w-[327px] desk:w-[960px] md:w-[564px] "
      >
        <div className={`flex flex-col w-full`}>
          <div
            className={`
            text-dblue
            text-left
            font-inter
            font-medium
            leading-normal
            mb-[-8px]
             
            text-[20px]
            
            md:mb-[4px]

            desk:mb-[6px]
            desk:text-[40px]

			
            `}
          >
            <h1>
              {t("scrap_metal_price_index") +
                (countryName !== "International" ? ` - ${t(countryName)}` : "")}
            </h1>
          </div>

          <div className={textClass}>
            <p>
              {countryName !== "International"
                ? t("country_price_description", { country: t(countryName) })
                : t("main_price_description")}
            </p>
          </div>
        </div>
        <div className="flex w-full mt-[16px] desk:mt-[22px]">
          <MetaButton
            className="flex"
            as="link"
            url={url}
            dataEvent={dataEvent}
            theme={"white-bg"}
          >
            {t("About_Button1")}
          </MetaButton>
        </div>
      </div>
    </div>
  )
}

export default MainTitleAndDescription
